import React from 'react';
import {Cell} from '../Cell/Cell';
import {ProductGalleryLayout} from '../../ProductGallery/ProductGalleryLayout/ProductGalleryLayout';
import {LayoutComponentProps} from '../../../types/app-types';
import {GalleryNavigationType, Layout, MarginBottom} from '../../../constants';
import s from './SimpleLayout.scss';
import {createLayoutConfigWithDefaults} from '../../ProductGallery/ProductGalleryLayout/ProductGalleryLayoutUtils';
import classNames from 'classnames';
import {SPECS} from '../../../specs';

export const SimpleLayoutHeaderDataHook = {
  Header: 'simple-layout-header',
  Cell: 'simple-layout-cell',
};

export const SimpleLayoutHeader: React.FunctionComponent<LayoutComponentProps> = ({settings, globals}) => {
  const GALLERY_WIDTH = 980;
  const GALLERY_HEIGHT = 551;
  const {product, useExperiments} = globals;
  const isThumbnailsNavigation = settings.navigationType === GalleryNavigationType.THUMBNAILS;
  const isNewThumbnailsDesignEnabled = useExperiments.enabled(SPECS.ThumbnailsDesignViewer);

  return (
    <header className={s.header} data-hook={SimpleLayoutHeaderDataHook.Header}>
      <Cell
        className={classNames(s.gallery, {
          [s.thumbnailsSpacing]: isThumbnailsNavigation && isNewThumbnailsDesignEnabled,
        })}
        dataHook={SimpleLayoutHeaderDataHook.Cell}>
        <ProductGalleryLayout
          product={product}
          layoutConfig={createLayoutConfigWithDefaults({
            marginBottom: isThumbnailsNavigation ? MarginBottom.LARGE : MarginBottom.SMALL,
            dimensions: {
              mainMedia: {
                widthConf: {num: GALLERY_WIDTH, unit: 'px'},
                heightConf: {num: GALLERY_HEIGHT, unit: 'px'},
              },
              thumbnails: {
                widthConf: {num: GALLERY_WIDTH, unit: 'px'},
                heightConf: {num: 50, unit: 'px'},
              },
            },
          })}
          layout={Layout.Simple}
          {...settings}
        />
      </Cell>
    </header>
  );
};
